import styled from 'styled-components'

const GlobalWrapper = styled.div`
  display: block;
  //width: 100vw;
  //height: 100vh;
`

export { GlobalWrapper }
